import React from "react";

import BenefitInfoPageRoute from "../components/benefit/BenefitInfoPageRoute";

const BenefitInformation = () => {
	return (
		<div className="main-wrap benefit-information" style={{ paddingTop: 0 }}>
			<div className={`max-width-apply`}>
				<img
					src={`${process.env.REACT_APP_S3_HOST}/image/together/benefit/together-benefit-1.png`}
					alt={`together-benefit`}
					style={{
						width: "100%",
						height: "auto",
						objectFit: "cover",
						border: "none",
					}}
				/>
				<img
					src={`${process.env.REACT_APP_S3_HOST}/image/together/benefit/together-benefit-2.png`}
					alt={`together-benefit`}
					style={{
						width: "100%",
						height: "auto",
						objectFit: "cover",
						border: "none",
					}}
				/>
				<img
					// src={`${process.env.REACT_APP_S3_HOST}/image/together/benefit/together-benefit-3.png`}
					src={`/assets/images/benefit/info-3.png`}
					alt={`together-benefit`}
					style={{
						width: "100%",
						height: "auto",
						objectFit: "cover",
						border: "none",
					}}
				/>
				<BenefitInfoPageRoute />
			</div>
		</div>
	);
};

export default BenefitInformation;
